import { CheckCircleIcon, XCircleIcon } from "@phosphor-icons/react";
import clsx from "clsx";
import { type ReactNode } from "react";
import { useIntl } from "react-intl";

type Props = {
  isIncluded: boolean;
  label: ReactNode;
};

export const RoomFeature = ({ isIncluded, label }: Props) => {
  return (
    <div className="flex gap-1 text-sm">
      <div className="shrink-0">
        {isIncluded ? (
          <CheckCircleIcon
            size={18}
            weight="bold"
            color="var(--color-core-accent-500)"
          />
        ) : (
          <XCircleIcon
            size={18}
            weight="bold"
            color="var(--color-text-disabled-tertiary)"
          />
        )}
      </div>
      <span
        className={clsx({
          "font-medium text-core-rahal-600": isIncluded,
          "text-text-primary": !isIncluded,
        })}
      >
        {label}
      </span>
    </div>
  );
};

export const MealFeature = ({ board }: { board: string }) => {
  const intl = useIntl();

  if (board === "BB") {
    return (
      <RoomFeature
        isIncluded
        label={intl.formatMessage({
          id: "hotels.mealOptions.breakfastIncluded",
          defaultMessage: "Breakfast included",
        })}
      />
    );
  }

  if (board === "HB") {
    return (
      <RoomFeature
        isIncluded
        label={intl.formatMessage({
          id: "hotels.mealOptions.breakfastAndDinnerIncluded",
          defaultMessage: "Breakfast and dinner included",
        })}
      />
    );
  }

  if (board === "FB") {
    return (
      <RoomFeature
        isIncluded
        label={intl.formatMessage({
          id: "hotels.mealOptions.breakfastLunchAndDinnerIncluded",
          defaultMessage: "Breakfast, lunch and dinner included",
        })}
      />
    );
  }
  if (board === "AI") {
    return (
      <RoomFeature
        isIncluded
        label={intl.formatMessage({
          id: "hotels.mealOptions.allInclusive",
          defaultMessage: "All inclusive",
        })}
      />
    );
  }

  return (
    <RoomFeature
      isIncluded={false}
      label={intl.formatMessage({
        id: "hotels.mealOptions.breakfastNotIncluded",
        defaultMessage: "Breakfast not included",
      })}
    />
  );
};
